<hr style="margin-top: 0px; margin-bottom: 0px;">

<div *ngIf="awaitUserGroups && awaitAssociatedUserGroups; else loading">
  <div class="col-md-12">
    <p-confirmDialog #cd>
      <ng-template #footer>
        <button (click)="cd.onAccept()" class="btn btn-success" type="button">Yes</button>
        <button (click)="cd.onReject()" class="btn btn-basic" type="button">No</button>
      </ng-template>
    </p-confirmDialog>

    <p-table #userGroupTable [columns]="userGroupCols" [value]="userGroups" sortField="name" [scrollable]="true" scrollHeight="65vh">

      <ng-template let-columns pTemplate="header">
        <tr>
          <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template let-columns="columns" let-rowData pTemplate="body">
        <!-- <tr *ngIf="rowData.userFeatureAccess['ViewListing'] || global.globalSwitch" style="height: 40px;"> -->
        <tr style="height: 40px;">
          <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
            {{rowData.name}}
          </td>

          <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
            {{rowData.description}}
          </td>

          <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
            {{ rowData.lastModifiedDate | date : 'medium' }}
          </td>

          <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
            <div class="css-tooltip" style="color: black; cursor: pointer; font-size: 14px;" [attr.tooltip-data]="rowData.userList"><i class="fas fa-user-friends "></i>&nbsp;&nbsp;&nbsp;({{ rowData.userInfos.length }})</div>
          </td>

          <td class="modifications" [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;"> 
            <div *ngIf="rowData.userFeatureAccess['EditUserGroup']" (click)="editUserGroup(rowData,template)"
                  aria-hidden="true" class="fas fa-pencil-alt" style="color:#64a70b; cursor: pointer; font-size: 14px;">
            </div>
          </td>

          <td class="modifications" [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
            <div *ngIf="rowData.userFeatureAccess['DeleteUserGroup']" (click)="onDeleteUserGroupConfirm(rowData)"
                  aria-hidden="true" class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;">
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template let-columns pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="columns.length">
            No records found
          </td>
        </tr>
      </ng-template>
      <ng-template let-rowData pTemplate="caption">
        <div style="text-align: left; margin-top: 10px; margin-bottom: 10px;">
          <label style="font-size: large; vertical-align: middle; color:black; padding-right: 20px; font-weight: 500;">USER GROUPS</label>
          <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
          <input (input)="userGroupTable.filterGlobal($event.target.value, 'contains')" pInputText placeholder="Search" size="30"
                  style="width:auto; height: 30px" type="text" [(ngModel)]="userGroupSearchText">
          <button style="float: right; margin-top: 0px; padding-top: 3px;" (click)="addUserGroup(template)" class="btn btn-success" type="button">Create User Group</button>
        </div>
      </ng-template>

      <ng-template let-rowData pTemplate="summary">
      </ng-template>
      
    </p-table>
  </div>
</div>


<ng-template #loading>
  <div class="col-xs-4 col-lg-3">
    <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="margin: 10px;"></i>
    <span>Loading...</span>
  </div>
</ng-template>


<ng-template #template>
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="editUsers-modal">
  <!-- <div class="modal-content editUsers-modal"> -->
    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
      <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Edit User Group: {{userGroupTitle}}</h5>
      <button
        (click)="modalRef.hide()"
        class="ms-auto fas fa-times" type="button"
        style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
      </button>
    </div>
    <div class="modal-body">
      <div class="container-fluid">
        <div class="col-md-12">
          <form #userGroupEditor="ngForm" (ngSubmit)="updateUserGroup()">

            <div class="form-group" style="margin-bottom: 20px;">
              <label for="userGroupName" style="font-weight: 500;">Name*</label>
              <input [(ngModel)]="userGroup.name" class="form-control" id="userGroupName" name="userGroupName" required
                     [style.color]="!duplicateName ? 'black' : 'red' " (ngModelChange)="duplicateNamecheck(userGroup.name)" type="text">
            </div>

            <div class="form-group" style="margin-bottom: 20px;">
              <label for="description" style="font-weight: 500;">Description*</label>
              <input [(ngModel)]="userGroup.description" class="form-control" id="description" name="description"
                    required type="text">
            </div>
            
            <div class="form-group">
              <p-table #usersTable [columns]="userCols" [scrollable]="true" [value]="userGroup.userInfos" scrollHeight="20em">
                <ng-template let-rowData pTemplate="caption">
                  <div style="display: flex; justify-content: space-between;">
                    <label style="font-size: medium;">Users</label>
                    <button (click)="addUser(usertemplate)" class="btn btn-primary"  type="button">Add User</button>
                  </div>
                </ng-template>

                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                      {{col.header}}
                    </th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-columns="columns" let-i="rowIndex" let-rowData>
                  <tr [ngStyle]= "{ 'backgroundColor' : (rowData.changed) ? '#a9d18e' : 'white' }" style="height: 40px;">
                    <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px; padding: 0 10px 0 10px; vertical-align: middle;">
                      {{ rowData.userName }}
                    </td>

                    <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px; padding: 0 10px 0 10px; vertical-align: middle;">
                      <div *ngIf="username==rowData.userName">
                        {{ rowData.role }}
                      </div>
                      <div *ngIf="username!=rowData.userName">
                        <select name="{{'UserInfo' + rowData.id}}" [(ngModel)]="rowData.role" style="height:35px; width: 200px; border-color: darkgray;" (ngModelChange)="updateUserDetails(rowData)">
                          <option [value]="i" *ngFor="let i of UserRolesDDOptions">{{i}}</option>
                        </select>
                      </div>
                    </td>

                    <td [ngStyle]="{'width': columns[2].width}" class="text-center" style="flex: none; border-width: 0px; padding: 0 10px 0 10px;">
                      <div *ngIf="username!=rowData.userName" (click)="onDeleteUserConfirm(rowData)" aria-hidden="true"
                                    class="far fa-trash-alt" style="color: #c8102e; cursor: pointer; font-size: 14px; margin-top: 14px;"></div>
                      <span class="sr-only">Delete</span>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>

            <br>
            <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
            <button [disabled]="!userGroupEditor.form.valid" class="btn btn-success col-xs-5 pull-right" type="submit">{{buttonValue}}</button>
            <button (click)="modalRef.hide()" class="btn btn-basic col-xs-5 pull-right" style="margin-right: 10px; margin-bottom: 15px;" type="button">Cancel</button>

          </form>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #usertemplate>
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="search-modal">
  <!-- <div class="modal-content search-modal"> -->
    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
      <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Search for Users</h5>
      <!-- <button (click)="userModalRef.hide()" aria-label="Close" class="close pull-right" type="button"><span
        aria-hidden="true">&times;</span></button> -->
      <button
        (click)="userModalRef.hide()"
        class="ms-auto fas fa-times" type="button"
        style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
      </button>
    </div>
    <div class="modal-body">
      <div class="container-fluid">
        <div style="display: flex; gap: 0px; align-items: stretch;">
          <div class="col-xs-8 col-md-6">
            <div class="input-group">
              <input (keyup.enter)="getUsersByLastName()" [(ngModel)]="lastName" class="form-control" id="txtSearch"
                    placeholder="Enter full or partial last name" type="text" />
              <div class="input-group-btn">
                &nbsp;
                <button (click)="getUsersByLastName()" class="btn btn-primary" type="button">
                  <span class="fas fa-search"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <br>
        <div *ngIf="userInfos.length > 0" style="display: flex; gap: 0px; align-items: stretch;">
          <div class="col-md-12">
            <p-table #searchTable [columns]="adUserCols" [scrollable]="true" [value]="userInfos" scrollHeight="30em">
              <ng-template pTemplate="caption">
                <div style="text-align: left">
                  <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                  <input (input)="searchTable.filterGlobal($event.target.value, 'contains')" pInputText placeholder="Search" size="40" style="height: 30px;" type="text">
                </div>
              </ng-template>
              <ng-template let-columns pTemplate="header">
                <tr>
                  <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                    {{col.header}}
                    <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>

              <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                <tr style="height: 40px;">
                  <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                    {{rowData.displayName}}
                  </td>
                  <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                    {{rowData.mail}}
                  </td>
                  <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                    {{rowData.givenName}}
                  </td>
                  <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                    {{rowData.surname}}
                  </td>
                  <td [ngStyle]="{'width': columns[4].width}" class="text-center" style="flex: none; border-width: 0px;">
                    <button (click)="addAdUser(rowData)" class="btn btn-primary btn-sm" type="button">Add</button>
                  </td>
                </tr>
              </ng-template>

            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
